var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"geographic-search"}},[_c('SpatialMap'),_c('div',{staticClass:"searchbar"},[_c('b-button',{staticClass:"btn-search",attrs:{"disabled":!_vm.isSearchable,"pill":"","size":"lg","variant":"info"},on:{"click":function($event){return _vm.onConfirm()}}},[_vm._v("Search ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }